import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash';
import {WeaErrorPage, WeaTools, WeaTable, WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const { ls } = WeaTools;
import Title from './Title';
import { formatData ,setContentviewHeight } from '../../util/common';
//内容组件
class MyProjectsCom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabdata: props.edata.data,
            currentTab: props.edata.currenttab,
            refresh: false,
        }
        this.handleTabData = this.handleTabData.bind(this);
    }

    componentWillReceiveProps(nextProps){
        // if(!isEqual(nextProps, this.props)){
            this.setState({
                tabdata: nextProps.edata.data,
                currentTab: nextProps.edata.currenttab,
                refresh: false,
            });
        // }
    }
    shouldComponentUpdate(nextProps, nextState){
        return !isEqual(this.state, nextState) || !isEqual(this.props, nextProps)
    }
    componentDidMount(){
        this.props.onRef(this);
    }
    handleTabData(tabid){
        const { params, isremembertab } = this.props.config;
        const { currentTab } = this.state;
        const tabdata_local = ls.getJSONObj('tabdata-' + params.eid + '-' + tabid);
        this.setState({
            refresh: tabid === currentTab,
            currentTab: tabid,
            tabdata: tabdata_local == null ? {} : tabdata_local,
        });
        WeaTools.callApi('/api/portal/element/projectstab', 'POST', {...params, tabid}).then(result => {
            ls.set('tabdata-' + params.eid + '-' + tabid, result);
            if(tabid === this.state.currentTab){
                this.setState({
                    tabdata: result,
                    refresh: false,
                });
                if(isremembertab){
                    let edata = ls.getJSONObj('edata-' + params.eid);
                    if(edata){
                        edata.currenttab = tabid;
                        edata.data = result;
                        ls.set('edata-' + params.eid, edata);
                    }
                }
            }
        });
    }
    render() {
        const { config, edata, handleRefresh, handleDelete, fontSizeMp } = this.props;
        const { tabdata, currentTab, refresh } = this.state;
        const { tabids, titles, esetting } = edata;
        const { datas={} } = tabdata;
        const { dataColoums=[] } = datas;
        esetting.dataColoums = dataColoums;
        let searchtype = '';
        let cmanager = '';
        let status = '';
        let eMoreShowType = '0';
        let eMoreAddress = '';
        const { eid } = config.params;
        const { contentview = {},header } = config.item;
        let cstyle = {height: contentview.style.height,overflow: "auto"};
        if(header.displayPosition && header.displayPosition == 'bottom'){
            if(tabids && tabids.length > 1 || tabids && tabids.length == 1 && esetting.isAlwaysShow=='1'){
                if(contentview.style.height){
                    if(esetting.tabstyle == '1' && esetting.tabvalue){
                        cstyle = setContentviewHeight(contentview.style.height,esetting.tabvalue)
                    }else{
                        cstyle = {height: parseInt(contentview.style.height)-32+"px",overflow: "auto"};
                    } 
                }else {
                    cstyle = {height: contentview.style.height,overflow: "auto"};
                }
                let elementH=parseInt(contentview.style.height)-parseInt($(`#titleContainer_${eid}`).css('height'));
                if(elementH!=parseInt(cstyle.height)){
                    if(elementH<parseInt(cstyle.height)){
                        cstyle.height=elementH+"px";
                    }
                }
            }
        }

        let contentHtml = <div/>;
        if(tabdata){
            if(datas.coworkList){
                contentHtml = <WeaTable ecId={`${this && this.props && this.props.ecId || ''}_WeaTable@ej2w4f`} columns = {formatData(tabdata.datas.coworkList[0], esetting)} showHeader={esetting.showHeader=='1'} pagination={false} dataSource={tabdata.datas.coworkList} size="small"/>;
            }
            /*          const tabsetting = tabdata.tabsetting;
                        const { isIE, readType, mess } = tabsetting;
                        if(readType == '1' && isIE != 'true') contentHtml = <div>&nbsp;&nbsp;{mess}</div>;*/
            searchtype = datas.searchtype;
            cmanager = datas.cmanager;
            status = datas.status;
            eMoreAddress = tabdata.datas && tabdata.datas.eMoreAddress;
            eMoreShowType = tabdata.datas && tabdata.datas.eMoreShowType;
        }
        const _titleProps = {
            currentTab,
            config,
            searchtype,
            cmanager,
            status,
            titles,
            tabids,
            handleRefresh,
            handleDelete,
            fontSizeMp,
            eMoreShowType,
            eMoreAddress,
            tabwidth: esetting.tabwidth,
            methodvalue: esetting.methodvalue,
            isAlwaysShow: esetting.isAlwaysShow,
            tabstyle: esetting.tabstyle,
            tabvalue: esetting.tabvalue,
            handleTabData: this.handleTabData
        }
        return <div>
            <Title ecId={`${this && this.props && this.props.ecId || ''}_Title@667vfm`} {..._titleProps}/>
            <div className="tabContant" id={`tabcontant_${eid}`} style={{height: cstyle.height,'overflow-y':'auto'}}>
                <Spin ecId={`${this && this.props && this.props.ecId || ''}_Spin@vp9v1f`} spinning={refresh}>{contentHtml}</Spin>
            </div>
        </div>;
    }
}

class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
        return ( <WeaErrorPage ecId={`${this && this.props && this.props.ecId || ''}_WeaErrorPage@8bodxz`} msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！") }/>
        );
    }
}
MyProjectsCom = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(MyProjectsCom);
export default MyProjectsCom;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/myprojects/MyProjects.js